import path from "../../../../packages/fnacdarty-svg-ref-loader/svg-id.js?id=$!./icon_i_309_volume_high.svg"; export default path + "#$"